import { CircularProgress } from '@mui/material';
import { useEffect, useRef } from 'react';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useNotificationStore } from '../../store/storeNotifications';
import { FormBuilderHeader } from './Components/FormBuilderHeader/FormBuilderHeader';
import { FormHeader } from './Components/FormHeader/FormHeader';
import { SettingsContainer } from './Components/Settings/SettingsContainer';
import Toolbar from './Components/ToolBar/Toolbar';
import {
  FormBuilderProvider,
  useFormBuilder,
} from './Context/FormBuilderContext';

import { FormsService } from '../../service/FormService';
import { FormContainer } from './Components/FormContainer/FormContainer';
import { FormTabs } from './Components/FormTabs/FormTabs';
import { PageNavigation } from './Components/PageNavigation/PageNavigation';

function FormBuilder() {
  const { state, loadingForm } = useFormBuilder();
  const setNotification = useNotificationStore(state => state.setNotification);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!state.form.id) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(async () => {
      try {
        await FormsService.update(state.form.id, state.form);
      } catch (error) {
        setNotification({
          type: 'error',
          message: 'Error updating form',
        });

        console.error('Error updating form:', error);
      }
    }, 500);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [state.form, setNotification]);

  if (loadingForm) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#FFFFFF',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F2F4F7',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <FormTabs />

      <FormHeader />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            padding: '16px 16px 24px 16px',
            gap: '16px',
            flex: 1,
            overflow: 'hidden',
          }}
        >
          <Toolbar />

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              flex: 1,
              height: '100%',
            }}
          >
            <FormBuilderHeader />

            <div style={{ display: 'flex', gap: '16px', height: '100%' }}>
              <FormContainer />
              <SettingsContainer />
            </div>
          </div>
        </div>

        <PageNavigation />
      </div>
    </div>
  );
}

export default function FormLayout() {
  return (
    <FormBuilderProvider>
      <FormBuilder />
    </FormBuilderProvider>
  );
}
